import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { UAParser } from 'ua-parser-js';
const parser = new UAParser(typeof window !== 'undefined' ? window.navigator.userAgent : '');
const device = parser.getDevice();
const browser = parser.getBrowser();
export const isMobile = device.type === 'mobile' || device.type === 'tablet';
export const isSafari = browser.name === 'Safari';
export const MobileView = ({ children }) => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient || !isMobile)
        return null;
    return _jsx(_Fragment, { children: children });
};
export const BrowserView = ({ children }) => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient || isMobile)
        return null;
    return _jsx(_Fragment, { children: children });
};
